import styled from "styled-components";
import { StandardButton } from "../buttons/standard-button";

// tslint:disable-next-line
export const ActionMenuLabelsUnassignButton = styled(StandardButton)`
  display: block;
  min-width: 40px;
  margin: 10px 5px 0px 5px;
`;
